import { useState } from "react";
import "./Emergency.css";
import Disclaimer from "./Disclaimer";
import logo from "./assets/logo.png";

const clean = (num) => num?.replace(/\D/g, "");

function Emergency({ data }) {

    const [showPopup, setShowPopup] = useState(false);
    const [selectedNumber, setSelectedNumber] = useState(null);

    const openPopup = (number) => {
        setSelectedNumber(number);
        setShowPopup(true);
    };

    const handleConfirmCall = () => {
        const phone = clean(selectedNumber);

        if (!phone) {
            alert("Invalid phone number");
            return;
        }

        window.location.href = `tel:+91${phone}`;
    };

    return (
        <div>

            {/* Logo */}
            <div className="logo-container">
                <img src={logo} alt="Scan4Help" className="logo" />
            </div>

            {/* Disclaimer */}
            <Disclaimer />

            <div className="emergency-container">

                <div className="emergency-header">
                    🚨 Emergency Contacts
                </div>

                {/* Owner */}
                <div className="card emergency">
                    <div className="card-title">Owner</div>
                    <div className="name">{data.vehicleOwnerName}</div>

                    <button
                        className="call-btn"
                        onClick={() => openPopup(data.vehicleOwnerNumber)}
                    >
                        <span className="phone-icon">📞</span>
                        Call
                    </button>
                </div>

                {/* Primary */}
                <div className="card emergency">
                    <div className="card-title">Primary Emergency Contact</div>
                    <div className="name">{data.primaryEmergencyContactName}</div>

                    <button
                        className="call-btn"
                        onClick={() => openPopup(data.primaryEmergencyContactNumber)}
                    >
                        📞 Call
                    </button>
                </div>

                {/* Secondary */}
                <div className="card">
                    <div className="card-title">Secondary Contact</div>
                    <div className="name">{data.secondaryEmergencyContactName}</div>

                    <button
                        className="call-btn"
                        onClick={() => openPopup(data.secondaryEmergencyContactNumber)}
                    >
                        📞 Call
                    </button>
                </div>

                {/* Relative */}
                <div className="card">
                    <div className="card-title">Relative / Friend</div>
                    <div className="name">{data.dearestRelativeContactName}</div>

                    <button
                        className="call-btn"
                        onClick={() => openPopup(data.dearestRelativeContactNumber)}
                    >
                        📞 Call
                    </button>
                </div>

                {/* Footer */}
                <div className="footer-note">
                    Scan4Help • One Scan Can Save a Life
                </div>

            </div>

            {/* 🔥 CUSTOM POPUP */}
            {showPopup && (
                <div className="popup-overlay">
                    <div className="popup">

                        <h3>⚠️ Responsible Use</h3>

                        <p>
                            This service is designed to assist in genuine emergency situations.
                        </p>

                        <p className="sub">
                            We kindly request you to use it responsibly and avoid any misuse.
                        </p>

                        <div className="popup-actions">

                            <button
                                className="cancel-btn"
                                onClick={() => setShowPopup(false)}
                            >
                                Cancel
                            </button>

                            <button
                                className="call-confirm-btn"
                                onClick={handleConfirmCall}
                            >
                                📞 Call
                            </button>

                        </div>

                    </div>
                </div>
            )}
        </div>
    );
}

export default Emergency;